import { patchState, signalStoreFeature, withMethods } from "@ngrx/signals";
import { ApiOffersService } from "../../services/api-offers.service";
import { inject } from "@angular/core";
import { removeEntity, setEntity, updateEntity } from "@ngrx/signals/entities";
import { BackOfficeOfferViewModel } from "@playcharge/common/models/backend/offers/backoffice/backoffice-offer-view-model";
import { CopyOfferDataEditModel } from "@playcharge/common/models/backend/offers/backoffice/copy-offer-data-edit-model";
import { Observable, tap } from "rxjs";
import { CreateOfferEditModel } from "@playcharge/common/models/backend/offers/backoffice/create-offer-edit-model";

export function withOffersMethods() {
    return signalStoreFeature(
        withMethods((store, apiOffersService = inject(ApiOffersService)) => ({
            setOffer(offer: BackOfficeOfferViewModel) {
                patchState(store, setEntity(offer));
            },
            publishOffer(offerId: number): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .publish(offerId)
                    .pipe(tap((offer) => patchState(store, setEntity(offer))));
            },
            archiveOffer(offerId: number): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .archive(offerId)
                    .pipe(tap((offer) => patchState(store, removeEntity(offer.id))));
            },
            createOffer(model: CreateOfferEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .createOffer(model)
                    .pipe(tap((offer) => patchState(store, setEntity(offer))));
            },
            copyOffer(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .copyOffer(model)
                    .pipe(tap((offer) => patchState(store, setEntity(offer))));
            },
            copyFullOffer(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .copyFullOffer(model)
                    .pipe(tap((offer) => patchState(store, setEntity(offer))));
            },
            validateOffer(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .validateOffer(model)
            },
            activateOffer(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .activateOffer(model)
                    .pipe(tap(() => patchState(store, updateEntity<BackOfficeOfferViewModel>({ id: model.offerId, changes: { isActive: true } })),));
            },
            deactivateOffer(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .deactivateOffer(model)
                    .pipe(tap(() => patchState(store, updateEntity<BackOfficeOfferViewModel>({ id: model.offerId, changes: { isActive: false } })),));
            },
            copyOfferGoals(model: CopyOfferDataEditModel): Observable<BackOfficeOfferViewModel> {
                return apiOffersService
                    .copyOfferGoals(model)
                    .pipe(tap((offer) => patchState(store, setEntity(offer))));
            },
            uploadIdfaCsv(file: File): Observable<void> {
                return apiOffersService.uploadIdfaCsv(file);
            },
        })),
    );
}
